import React from 'react';
import { Logout } from '../auth/AuthService';

export type AuthenticationErrorProps = {
  message?: string;
  buttonText?: string;
  onClick?: () => void;
};

export function AuthenticationError(props: AuthenticationErrorProps) {
  const genericErrorMsg = 'There was an error loading your account. Please try again. If this issue persists, please contact support';
  const genericRetry = 'Click here to retry';
  const backToLogin = 'Back to Login';

  const handleButtonClick = () => {
    if (typeof props.onClick === 'function') {
      props.onClick();
      return;
    }

    window.location.reload();
  };

  return (
    <div className="authentication-error">
      <div className="authentication-error-message">{props.message || genericErrorMsg}</div>
      <button className="link-button" onClick={() => handleButtonClick()}>
        {props.buttonText || genericRetry}
      </button>
      <br />
      <br />
      <button className="link-button" onClick={() => Logout()}>
        {backToLogin}
      </button>
    </div>
  );
}
